<div class="flex justify-center">
    <div class="pt-6 px-2 pb-12 max-w-screen-md w-full flex flex-col">
        <h2 class="text-center pb-4">Auswertung Prüfungssimulation {{examSimName}}</h2>
        <div class="flex flex-row items-center justify-between pb-7 text-black dark:text-white">
            @if (score >= treshold) {
            <p>Ergebnis: {{score | number:'1.2-2'}}% (bestanden)</p>
            } @else {
            <p>Ergebnis: {{score | number:'1.2-2'}}% (nicht bestanden)</p>
            }
            <p>Benötigte Zeit: {{ timeTaken * 1000 | date:'mm:ss' }} Minuten</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 font-semibold pb-1 gap-2">
            <button (click)="setActiveButton(0); showAllAnswerComponents()"
                [ngClass]="buttonStates[0] ? 'blue-button' : 'white-button'">
                <span>Übersicht</span>
            </button>
            <button (click)="buttonStates[1] ? showAllAnswerComponents() : filterByCorrect(true); setActiveButton(1)"
                [ngClass]="buttonStates[1] ? 'blue-button' : 'white-button'">
                <span>Richtige ({{ renderedComponentCounts['all'] }})</span>
            </button>
            <button (click)="buttonStates[2] ? showAllAnswerComponents() : filterByCorrect(false); setActiveButton(2)"
                [ngClass]="buttonStates[2] ? 'blue-button' : 'white-button'">
                <span>Falsche ({{ renderedComponentCounts['none'] + renderedComponentCounts['some'] }})</span>
            </button>
            <button (click)="buttonStates[3] ? showAllAnswerComponents() : filterByFlagged(); setActiveButton(3)"
                [ngClass]="buttonStates[3] ? 'blue-button' : 'white-button'">
                <span>Markierte ({{renderedComponentCounts['flagged']}})</span>
            </button>
        </div>

        <div #fadediv class="grid grid-cols-1transition-all duration-500 divide-y md:divide-y-0">

            @for (evaluation of testResult?.evaluations; track evaluation; let index = $index) {
            <app-answer class="py-3" [evaluation]="evaluation.evaluation" [question]="evaluation.question"
                [flagged]="isQuestionFlagged(evaluation.question.id)"
                [bookmarked]="isQuestionBookmarked(evaluation.question.id)" [index]="index + 1"
                [total]="testResult?.evaluations?.length || 0"
                [bookmarkInfo]="evaluation.responseId ? {responseId: evaluation.responseId, courseId: courseId} : undefined"
                [orderSeed]="evaluation.orderSeed"></app-answer>
            }
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 font-semibold pt-3 gap-2">
            <a [routerLink]="['/test/create', testResult?.test?.conditions]" class="w-full">
                <button class="white-button w-full md:w-auto">
                    <span>Neue Prüfungssimulation</span>
                </button>
            </a>
            <a routerLink="/" class="w-full md:flex md:justify-end">
                <button class="blue-button w-full md:w-auto">
                    <span>Zur Übersicht</span>
                </button>
            </a>

        </div>

    </div>
</div>

<app-modal #achievementModal>
    <div class="flex flex-col items-center text-center h-full">
        <img src="./assets/img/penguin-with-squid.png" alt="Neuer Erfolg"
            class="mt-12 mb-6 w-40 h-40 rounded-full" />
        <h3 class="pb-4">Neuer Erfolg freigeschaltet!</h3>
        <p class=" text-lg font-bold text-orange">Prüfung {{ achievement?.achievement?.expand?.exam?.name }} {{
            achievement?.achievement?.count }}x bestanden!</p>
        <p>Super gemacht!</p>
        @if (achievement?.nextCount) {
        <p>Nächstes Ziel: {{ achievement?.nextCount }} bestandene Prüfungssimulationen</p>
        }
        <button class="blue-button mt-10 w-3/4" (click)="toggleAchievementModal()">Yaay!</button>
    </div>
</app-modal>